import Button from "@/components/common/button/Button";
import Input from "@/components/common/input/Input";
import ApiErrorAlert from "@/components/layout/message/ApiErrorAlert";
import { Eye, EyeOff } from "lucide-react";
import React from "react";
import styles from "./LoginForm.module.css";
import { useLoginForm } from "./useLoginForm";

const LoginForm: React.FC = () => {
    const { state, handleInputChange, handleSubmit, togglePasswordVisibility } =
        useLoginForm();

    const submitButtonContent =
        state.loginStatusMessage === "✓ Acceso concedido"
            ? state.loginStatusMessage
            : "INICIAR SESIÓN";

    return (
        <div className={styles["login-form-auth-box"]}>
            <div className={styles["login-form-header"]}>
                <h2 className={styles["login-form-title"]}>Inicia sesión</h2>
                <p className={styles["login-form-subtitle"]}>
                    Ingresa tus credenciales para acceder a tu cuenta
                </p>
            </div>

            <form className={styles["login-form-fields"]} onSubmit={handleSubmit}>
                <ApiErrorAlert error={state.error} title="Error de inicio de sesión" />

                <Input
                    label="Correo electrónico"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="correo@ejemplo.com"
                    value={state.formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    error={state.error?.fieldErrors?.email}
                    disabled={state.isLoading}
                    autoComplete="email"
                    required
                />

                <div className={styles["login-password-input-wrapper"]}>
                    <Input
                        label="Contraseña"
                        id="password"
                        name="password"
                        type={state.passwordVisibility ? "text" : "password"}
                        placeholder="••••••••"
                        value={state.formData.password}
                        onChange={(e) => handleInputChange("password", e.target.value)}
                        error={state.error?.fieldErrors?.password}
                        disabled={state.isLoading}
                        autoComplete="current-password"
                        required
                    />
                    <button
                        type="button"
                        className={styles["login-password-toggle"]}
                        onClick={togglePasswordVisibility}
                        disabled={state.isLoading}
                        aria-label={state.passwordVisibility ? "Ocultar contraseña" : "Mostrar contraseña"}
                    >
                        {state.passwordVisibility ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                </div>

                <Button
                    type="submit"
                    variant="primary"
                    isLoading={state.isLoading}
                    loadingText={state.loginStatusMessage || "Iniciando sesión..."}
                    fullWidth
                    className={styles["login-submit-button"]}
                >
                    {submitButtonContent}
                </Button>
            </form>
        </div>
    );
};

export default LoginForm;
